import IconContainer, { IconContainerProps } from "./IconContainer"

export default function IconGoBack(props: IconContainerProps) {
    return <IconContainer size={props.size}>
        arrow_back_ios_new
    </IconContainer>
}